import DynamicSVG from "aldoo-ra/DynamicSVG"

const renderIcon = (item, recolor = true) => {
  const isSVG = item.image && item.image.includes(".svg")
  return (
    <div className="flex items-center justify-center h-8">
      {isSVG ? (
        <DynamicSVG url={item.image} recolor={recolor} className="object-contain w-full h-full" />
      ) : (
        <img src={item.image} alt={item.label || item.name || ""} className="object-contain" />
      )}
    </div>
  )
}

export default renderIcon
